import React, { useState, useEffect, useRef, useCallback } from 'react'
import clsx from 'clsx'

import classes from './LanguagePicker.module.scss'
import LanguageIcon from '../LanguageIcon'
import { useTranslation } from 'react-i18next'
import DropdownArrowIcon from '../DropdownArrowIcon'

type LanguagePickerProps = {
  className?: string
}

const languages = [
  {
    code: 'de',
    label: 'Deutsch',
  },
  {
    code: 'en',
    label: 'English',
  },
]

const LanguagePicker = ({ className }: LanguagePickerProps) => {
  const { i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const isOpen = Boolean(anchorEl)

  const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : e.currentTarget)
  }

  const handleGlobalClick = useCallback((e: MouseEvent) => {
    // Close the dropdown if the click is outside of the dropdown container
    if (!dropdownRef.current?.contains(e.target as Node)) {
      setAnchorEl(null)
    }
  }, [])

  const createHandleLanguageClick = (language: string) => () => {
    i18n.changeLanguage(language)
  }

  const dropdownPosition = anchorEl && {
    top: anchorEl?.getBoundingClientRect?.()?.top,
    right: window.innerWidth - anchorEl?.getBoundingClientRect?.()?.right,
  }

  useEffect(() => {
    if (anchorEl) {
      document.addEventListener('click', handleGlobalClick)

      return () => document.removeEventListener('click', handleGlobalClick)
    }
  }, [anchorEl, handleGlobalClick])

  return (
    <>
      <button
        className={clsx(classes.button, className)}
        onClick={handleToggle}
      >
        <LanguageIcon className={classes.icon} />{' '}
        <DropdownArrowIcon className={classes.dropdownArrow} />
      </button>

      {isOpen && (
        <div
          className={classes.dropdownContainer}
          style={dropdownPosition}
          ref={dropdownRef}
        >
          <ul className={classes.menu}>
            {languages.map((language) => (
              <li
                key={language.code}
                className={clsx(classes.menuItem, {
                  [classes.menuItemSelected]: language.code === i18n.language,
                })}
                onClick={createHandleLanguageClick(language.code)}
              >
                <LanguageIcon className={classes.icon} /> {language.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

export default LanguagePicker
